import React from 'react';
import { IStoreInfoColumnProps } from '../regular/types';
import StoreInfoColumn from '../../components/store-info-column';
import { trackShopLogoClick } from '../../tracking';

const PriceRowStoreInfoColumn: React.FC<IStoreInfoColumnProps> = props => {
  const { store, expanded, rating } = props;

  return (
    <>
      {store && (
        <div
          role="none"
          onClick={e => {
            trackShopLogoClick(store.id);
          }}
        >
          <StoreInfoColumn store={store} hide={expanded} rating={rating} />
        </div>
      )}
    </>
  );
};

export default PriceRowStoreInfoColumn;
